"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateScriptConfiguration = exports.parseScriptConfiguration = exports.ZScriptConfiguration = void 0;
const zod_1 = require("zod");
const numbering_1 = require("./numbering");
const blocks_1 = require("./blocks");
const margins_1 = require("./margins");
const ZScriptType = zod_1.z.enum(['ink']);
exports.ZScriptConfiguration = zod_1.z.object({
    scriptType: ZScriptType.optional(),
    browserPrint: zod_1.z.boolean().optional(),
    blocks: blocks_1.ZScriptBlocks,
    margins: margins_1.ZMarginConfiguration,
    numbering: numbering_1.ZNumberingConfig,
});
// this throws if a the input is invalid
const parseScriptConfiguration = async (input) => {
    const result = await exports.ZScriptConfiguration.parseAsync(input);
    return result;
};
exports.parseScriptConfiguration = parseScriptConfiguration;
const validateScriptConfiguration = (input) => exports.ZScriptConfiguration.safeParse(input);
exports.validateScriptConfiguration = validateScriptConfiguration;
